import dayjs from 'dayjs'

export function serializeObject (form) {
    /*
    const result = {}
    const data = $(form).serializeArray()

    $.each(data, (index, element) => {

        const node = result[element.name]

        if (typeof node !== 'undefined' && node !== null) {
            if ($.isArray(node)) {
                node.push(element.value)
            } else {
                result[element.name] = [node, element.value]
            }
        } else {
            result[element.name] = element.value
        }
    })

    return result
*/
}

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function getScript (url, callback = () => {}) {
    let head = document.querySelector('head');
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.onreadystatechange = arguments[1];
    script.onload = callback;
    head.appendChild(script);

}

export function randomString () {

    return (Math.random() + 1).toString(36).substr(2, 8)

}

export function parameterizeArray (key, arr) {

    arr = arr.map(encodeURIComponent)

    return `?${key}[]=${arr.join(`&${key}[]=`)}`

}

export function prettyDate (str, outputFormat = 'D.M.YYYY, H:mm [h]', inputFormat = 'YYYY-MM-DD HH:mm:ss') {

    const date = dayjs(str, inputFormat)

    return (date.isValid() ? date.format(outputFormat) : dayjs().format(outputFormat))

}

export function prettyNumber (str, decimals = 0) {

    return str.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

}

export function isEmail (str) {

    return /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/.test(str)

}

export function isPassword (str) {

    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/gm.test(str)

}

export function createSafePassword (strength = 12) {

    const characters = '0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    const uArray = new Uint32Array(characters.length)

    let password = '0Ab?'

    window.crypto.getRandomValues(uArray)

    for (let i = 0; i < strength; i++) {
        password += characters[uArray[i] % characters.length]
    }

    return password

}

export function extractOrigin (url) {

    try {

        const { origin } = new URL(url)

        return origin

    } catch (error) {

        return 'http://localhost:3000'

    }

}

export function hex2rgba (hex, alpha = 1) {

    const [r, g, b] = hex.match(/\w\w/g).map((x) => parseInt(x, 16))

    return `rgba(${r},${g},${b},${alpha})`

}

export function fixZIP (str = '') {

    return str.replace(/\D/g, '').substring(0, 5)

}


export function formatZIP(input) {
    let digits = String(input).replace(/\D/g, ''); // odstraní vše kromě číslic
    if(digits.length !== 5) return input; // pokud není délka 5, vrátí původní vstup
    return digits.slice(0, 3) + ' ' + digits.slice(3);
}

export function fixNullString (str = '') {

    str = (str ? str.toString() : '')

    return (str && str.length ? str : null)

}

export function relativeTime (dateString, inputFormat = 'YYYY-MM-DD HH:mm:ss') {

    const date = dayjs(dateString, inputFormat)
    
    if (!date.isValid()) {
        return dateString
    }

    const now = dayjs()
    const diffMinutes = now.diff(date, 'minute')
    const diffHours = now.diff(date, 'hour')
    const diffDays = now.diff(date, 'day')
    const diffWeeks = now.diff(date, 'week')
    const diffMonths = now.diff(date, 'month')
    const diffYears = now.diff(date, 'year')

    const pluralize = (count, singular, plural2to4, plural5plus) => {
        if (count === 1) return singular
        if (count >= 2 && count <= 4) return plural2to4
        return plural5plus
    }

    if (diffMinutes < 1) {
        return 'teď'
    } else if (diffMinutes < 60) {
        return `před ${diffMinutes} ${pluralize(diffMinutes, 'minutou', 'minutami', 'minutami')}`
    } else if (diffHours < 24) {
        return `před ${diffHours} ${pluralize(diffHours, 'hodinou', 'hodinami', 'hodinami')}`
    } else if (diffDays < 7) {
        return `před ${diffDays} ${pluralize(diffDays, 'dnem', 'dny', 'dny')}`
    } else if (diffWeeks < 4) {
        return `před ${diffWeeks} ${pluralize(diffWeeks, 'týdnem', 'týdny', 'týdny')}`
    } else if (diffMonths < 12) {
        return `před ${diffMonths} ${pluralize(diffMonths, 'měsícem', 'měsíci', 'měsíci')}`
    } else {
        return `před ${diffYears} ${pluralize(diffYears, 'rokem', 'lety', 'lety')}`
    }

}